"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkInsurancePaymentAdjustment_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var BulkInsurancePayment_1 = require("./BulkInsurancePayment");
var BulkInsurancePaymentAdjustment_Factory = /** @class */ (function () {
    function BulkInsurancePaymentAdjustment_Factory() {
    }
    BulkInsurancePaymentAdjustment_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            BulkInsurancePayment: BulkInsurancePayment_1.BulkInsurancePayment_Factory.CreateIncoming(model.BulkInsurancePayment),
            BulkPaymentId: model.BulkPaymentId,
            Comments: model.Comments,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    BulkInsurancePaymentAdjustment_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Amount: model.Amount,
            BulkInsurancePayment: BulkInsurancePayment_1.BulkInsurancePayment_Factory.CreateOutgoing(model.BulkInsurancePayment),
            BulkPaymentId: model.BulkPaymentId,
            Comments: model.Comments,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return BulkInsurancePaymentAdjustment_Factory;
}());
exports.BulkInsurancePaymentAdjustment_Factory = BulkInsurancePaymentAdjustment_Factory;
